/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import _cloneDeep from 'lodash/cloneDeep';
import { Analytics } from '../../../../analytics/sendAnalyticsEvent';
import { generateAnalyticsInteractionEvent } from '../utils/generateAnalyticsInteractionEvent';

export default (set, get) => {
  set(
    produce(get(), (draft) => {
      if (!draft.digitalData) {
        draft.digitalData = { event: [] };
      }
      const component = 'overlay';
      const section = 'add wall overlay';
      const target = 'add wall';
      const event = generateAnalyticsInteractionEvent(section, target, component);

      const eventClone = _cloneDeep(event);
      draft.digitalData.event.push(event);
      Analytics.sendAnalyticsEvent(eventClone);
    }),
    false,
    { type: 'ADD_WALL_INTERACTION_EVENT' }
  );
};